export default __webpack_public_path__ + "media/images/favicon-0d4a8d5d1255bebacbb4e63c82b66b93.png";